/**
 * Format date to a day string representation
 * @param date - input date to format
 */
export const formatDay = (date: Date) => date.getDate().toString();
